export default {
  computed: {
    companyName () {
      return this.$store.state.header?.headerData?.companyName ?? null
    }
  }
}
